/* eslint-disable react-refresh/only-export-components */
import { ApolloProvider } from '@apollo/client';
import { Capacitor } from '@capacitor/core';
import type { ReactElement } from 'react';
import React from 'react';
import { DndProvider } from 'react-dnd';
import ReactDOM, { render } from 'react-dom';
import { Provider as ReduxProvider } from 'react-redux';

import { store } from 'store';

import ApolloClient from 'common/graphql/client';
import { logNativeAppDetails } from 'common/utils/native_app_details';
import { logWebAppDetails } from 'common/utils/web_app_details';
import { CISnackBar } from 'common/viewcomp/general/ci_pagestatus';
import { CITheme } from 'common/viewcomp/general/CITheme';
import { Html5AndTouchBackend } from 'common/viewcomp/layout/dnd-multi-backend';

import App from './app';

if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_TEST_ACCESSIBILITY === 'true') {
    import('@axe-core/react').then(({ default: axe }): void => {
        axe(React, ReactDOM, 1000);
    });
}

if (Capacitor.isNativePlatform()) {
    logNativeAppDetails();
} else {
    logWebAppDetails();
}

const WithProvider = (): ReactElement => (
    <CITheme>
        <ReduxProvider store={store}>
            <CISnackBar />
            <ApolloProvider client={ApolloClient}>
                {/* TODO: REMOVE COMMENTED TAGS UNTIL MAJOR PACKAGES HAVE BEEN UPGRADED */}
                {/* <React.StrictMode> */}
                <DndProvider backend={Html5AndTouchBackend}>
                    <App />
                </DndProvider>
                {/* </React.StrictMode> */}
            </ApolloProvider>
        </ReduxProvider>
    </CITheme>
);

if (document.getElementById('root')) {
    render(<WithProvider />, document.getElementById('root'));
}
